import React from "react";
import { logAppError } from "../../api/adminService";
import AlertFailure from "../AlertFailure/AlertFailure";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error) {
      logAppError(String(error));
    }
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <AlertFailure />;
    }

    return this.props.children;
  }
}
